import React, { useState } from 'react';
import { CheckCircle2 } from 'lucide-react';
interface SignupFormProps {
  planName: string;
  planPrice: string;
  onClose: () => void;
}
export function SignupForm({
  planName,
  planPrice,
  onClose
}: SignupFormProps) {
  const [submitted, setSubmitted] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitted(true);
  };
  if (submitted) {
    return <div className="text-center py-8" data-id="element-316">
        <div className="w-16 h-16 mx-auto bg-green-100 rounded-full flex items-center justify-center mb-5" data-id="element-317">
          <CheckCircle2 className="w-8 h-8 text-green-600" data-id="element-318" />
        </div>
        <h3 className="text-2xl font-heading font-bold text-navy mb-2" data-id="element-319">
          You're in!
        </h3>
        <p className="text-muted mb-6 max-w-sm mx-auto" data-id="element-320">
          We've received your signup for the{' '}
          <span className="font-semibold text-navy" data-id="element-321">{planName}</span> plan. A
          team member will reach out within 24 hours to finalize your
          onboarding.
        </p>
        <button onClick={onClose} className="px-6 py-3 bg-navy text-white font-bold rounded-md hover:bg-navy-deep transition-colors" data-id="element-322">
          Close
        </button>
      </div>;
  }
  return <form onSubmit={handleSubmit} className="space-y-5" data-id="element-323">
      {/* Plan summary */}
      <div className="bg-blue-soft/60 border border-blue/10 rounded-lg p-4 flex items-center justify-between" data-id="element-324">
        <div data-id="element-325">
          <div className="text-xs uppercase tracking-wider text-muted font-semibold mb-0.5" data-id="element-326">
            Selected Plan
          </div>
          <div className="font-heading font-bold text-navy" data-id="element-327">{planName}</div>
        </div>
        <div className="text-right" data-id="element-328">
          <div className="text-2xl font-heading font-extrabold text-navy" data-id="element-329">
            {planPrice}
          </div>
          <div className="text-xs text-muted" data-id="element-330">per month</div>
        </div>
      </div>

      <div className="grid md:grid-cols-2 gap-4" data-id="element-331">
        <div data-id="element-332">
          <label className="block text-sm font-medium text-navy mb-1.5" data-id="element-333">
            Full Name *
          </label>
          <input type="text" required placeholder="John Doe" className="w-full px-4 py-2.5 rounded-md border border-gray-200 focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent text-sm" data-id="element-334" />
        </div>
        <div data-id="element-335">
          <label className="block text-sm font-medium text-navy mb-1.5" data-id="element-336">
            Business Name *
          </label>
          <input type="text" required placeholder="Acme Auto Repair" className="w-full px-4 py-2.5 rounded-md border border-gray-200 focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent text-sm" data-id="element-337" />
        </div>
      </div>

      <div className="grid md:grid-cols-2 gap-4" data-id="element-338">
        <div data-id="element-339">
          <label className="block text-sm font-medium text-navy mb-1.5" data-id="element-340">
            Email *
          </label>
          <input type="email" required placeholder="you@business.com" className="w-full px-4 py-2.5 rounded-md border border-gray-200 focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent text-sm" data-id="element-341" />
        </div>
        <div data-id="element-342">
          <label className="block text-sm font-medium text-navy mb-1.5" data-id="element-343">
            Phone *
          </label>
          <input type="tel" required placeholder="+1 (555) 123-4567" className="w-full px-4 py-2.5 rounded-md border border-gray-200 focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent text-sm" data-id="element-344" />
        </div>
      </div>

      <div data-id="element-345">
        <label className="block text-sm font-medium text-navy mb-1.5" data-id="element-346">
          Google Business Profile URL
        </label>
        <input type="url" placeholder="https://g.page/your-business" className="w-full px-4 py-2.5 rounded-md border border-gray-200 focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent text-sm" data-id="element-347" />
      </div>

      <div data-id="element-348">
        <label className="block text-sm font-medium text-navy mb-1.5" data-id="element-349">
          Tell us about your business
        </label>
        <textarea rows={3} placeholder="What's your industry, and what are your main goals?" className="w-full px-4 py-2.5 rounded-md border border-gray-200 focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent text-sm resize-none" data-id="element-350"></textarea>
      </div>

      <button type="submit" className="w-full py-3.5 bg-navy text-white font-bold rounded-md hover:bg-navy-deep transition-colors" data-id="element-351">
        Sign Up for {planName}
      </button>

      <p className="text-xs text-muted text-center" data-id="element-352">
        No credit card required to start. We'll reach out within 24 hours to set
        you up.
      </p>
    </form>;
}